import React, { useState } from 'react';

import { MultiAutocomplete } from '~/components/Form';
import { Select } from '~/components/Form/v2';
import { t } from '~/helpers';

import * as S from './styles';

export default function Filters({ params, setParams }) {
  const optionsDias = Array.from(Array(60).keys()).map((dias) => ({
    value: String(dias + 1),
    label: String(dias + 1),
  }));

  const optionsFilter = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Restrito ao usuário' },
  ];

  return (
    <S.DatePickerWrapper>
      <Select
        name="idagrupamento"
        label={t('Dias')}
        data={optionsDias}
        defaultValue={params.iddia}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            iddia: value.value,
          }))
        }
      />

      <Select
        name="idfilter"
        label={t('Filter')}
        data={optionsFilter}
        defaultValue={params.idfilter}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idfilter: value.value,
          }))
        }
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        getValue={(value) =>
          setParams((prevState) => ({
            ...prevState,
            idposto: value.map((posto) => posto.idposto),
          }))
        }
        filteruser={params.idfilter !== '0'}
      />
    </S.DatePickerWrapper>
  );
}
